<template>
	<ConfirmModal
		class="delete-item-modal"
		:title="title"
		:confirm-label="goBackBtnLabel"
		:cancel-label="null"
		@confirm="hideModal"
	>
		<!-- body -->
		<template #body>
			<p>
				{{ body }}
			</p>
		</template>
	</ConfirmModal>
</template>

<script>
import ConfirmModal from './ConfirmModal';

export default {
	name:       'ErrorModal',
	components: { ConfirmModal },
	props:      {
		title: {
			type:    String,
			default: 'Error',
		},
		body: {
			type: String,
		},
		goBackBtnLabel: {
			type:    String,
			default: 'Go back',
		},
		show: {
			type: Boolean,
		},
	},
	methods: {
		hideModal() {
			this.$emit('hide');
		},
	},
};
</script>

<style lang="scss" scoped>

.error-modal-icon {
	display: inline-flex;
	margin-top: -10px;
	margin-right: 20px;
}

.error-modal-title {
	display: inline-flex;
	position: relative;
	top: -10px;
}
</style>
